export default __webpack_public_path__ + "static/media/loading.259a837b.webp";